export const VARIANT_STANDARD = 'standard';
export const VARIANT_FULLWIDTH = 'fullwidth';